export enum ButtonType {
  Filled = 'filled',
  Outlined = 'outlined',
  Link = 'link',
  Ghost = 'ghost',
  Error = 'error',
}
